import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import { usePageConfig } from "./context/PageContext";
import LoadingScreen from "./LoadingScreen";

const AProtectedPageRoute = ({ pageKey }) => {
    const { user, role, loading } = useAuth();
    const { pages } = usePageConfig();

    const allowedRoles = ["OWNER", "DEV", "TESTER"];
    const pageEnabled = pages?.[pageKey] ?? false;

    if (loading) {
        return <LoadingScreen />;
    }

    if (pageEnabled === false) {

        if (!user || !role) {
            return <Navigate to="/unavailable" replace />;
        }

        if (!allowedRoles.includes(role)) {
            return <Navigate to="/unavailable" replace />;
        }

        return <Outlet />;
    }

    return <Outlet />;
};

export default AProtectedPageRoute;
